module.exports = __webpack_public_path__ + "static/media/no-wrkspace.ccbb70c0.svg";